(function($) {
    if ($("#filter-sidebar")) {
        History.Adapter.bind(window, "statechange", function() {
            var e = History.getState();
            if (!t.isSidebarAjaxClick) {
                t.sidebarParams();
                var n = t.sidebarCreateUrl();
                t.sidebarGetContent(n);
               
            }
            t.isSidebarAjaxClick = false
        })
    }
    jQuery('#search-top .icon-search').click(function(){
      jQuery('#search-top .search-form').fadeIn('300');
      jQuery('#search-top .search-form .inputbox').focus().css("color","#000");
    });
    jQuery('#search-top .search-close').click(function(){
      jQuery('#search-top .search-form').fadeOut('300');
    });

    jQuery('.menu-top .top-currency').hover(
      function () {
        jQuery(this).addClass('active').find('.top-bar-dropdown').stop().delay(200).slideDown();
      },
      function () {
        jQuery(this).removeClass('active').find('.top-bar-dropdown').stop().delay(200).slideUp();
      }
    );
    if (window.use_color_swatch) {
        $(".swatch :radio").change(function() {
            var t = $(this).closest(".swatch").attr("data-option-index");
            var n = $(this).val();
            $(this).closest("form").find(".single-option-selector").eq(t).val(n).trigger("change")
        });
      
        Shopify.optionsMap = {};
        Shopify.updateOptionsInSelector = function(t) {
            switch (t) {
                case 0:
                    var n = "root";
                    var r = $(".single-option-selector:eq(0)");
                    break;
                case 1:
                    var n = $(".single-option-selector:eq(0)").val();
                    var r = $(".single-option-selector:eq(1)");
                    break;
                case 2:
                    var n = $(".single-option-selector:eq(0)").val();
                    n += " / " + e(".single-option-selector:eq(1)").val();
                    var r = $(".single-option-selector:eq(2)")
            }
            var i = r.val();
            r.empty();
            var s = Shopify.optionsMap[n];
            for (var o = 0; o < s.length; o++) {
                var u = s[o];
                var a = $("<option></option>").val(u).html(u);
                r.append(a)
            }
            $('.swatch[data-option-index="' + t + '"] .swatch-element').each(function() {
                if ($.inArray($(this).attr("data-value"), s) !== -1) {
                    $(this).removeClass("soldout").show().find(":radio").removeAttr("disabled", "disabled").removeAttr("checked")
                } else {
                    $(this).addClass("soldout").hide().find(":radio").removeAttr("checked").attr("disabled", "disabled")
                }
            });
            if ($.inArray(i, s) !== -1) {
                r.val(i)
            }
            r.trigger("change")
        };
        Shopify.linkOptionSelectors = function(t) {
            for (var n = 0; n < t.variants.length; n++) {
                var r = t.variants[n];
                if (r.available) {
                    Shopify.optionsMap["root"] = Shopify.optionsMap["root"] || [];
                    Shopify.optionsMap["root"].push(r.option1);
                    Shopify.optionsMap["root"] = Shopify.uniq(Shopify.optionsMap["root"]);
                    if (t.options.length > 1) {
                        var i = r.option1;
                        Shopify.optionsMap[i] = Shopify.optionsMap[i] || [];
                        Shopify.optionsMap[i].push(r.option2);
                        Shopify.optionsMap[i] = Shopify.uniq(Shopify.optionsMap[i])
                    }
                    if (t.options.length === 3) {
                        var i = r.option1 + " / " + r.option2;
                        Shopify.optionsMap[i] = Shopify.optionsMap[i] || [];
                        Shopify.optionsMap[i].push(r.option3);
                        Shopify.optionsMap[i] = Shopify.uniq(Shopify.optionsMap[i])
                    }
                }
            }
            Shopify.updateOptionsInSelector(0);
            if (t.options.length > 1) Shopify.updateOptionsInSelector(1);
            if (t.options.length === 3) Shopify.updateOptionsInSelector(2);
            $(".single-option-selector:eq(0)").change(function() {
                Shopify.updateOptionsInSelector(1);
                if (t.options.length === 3) Shopify.updateOptionsInSelector(2);
                return true
            });
            $(".single-option-selector:eq(1)").change(function() {
                if (t.options.length === 3) Shopify.updateOptionsInSelector(2);
                return true
            })
        }
    }
  
    $(document).ready(function() {
        t.go()
    });
    $(window).resize(function() {
      
  
        t.goResizeImage()
    });
  
 var switchImage = function(newImageSrc, newImage, mainImageDomEl) {
     jQuery(mainImageDomEl).attr('src', newImageSrc);

    if ($(window).width() > 782) {jQuery(mainImageDomEl).parent().trigger('zoom.destroy').zoom( { url: newImageSrc.replace('_master', '') } );}

    $(mainImageDomEl).parents('a').attr('href', newImageSrc);

  };

   $(function () {
    $('[data-toggle="tooltip"]').tooltip()
  })
   
    var t = {
        atTimeout: null,
        isSidebarAjaxClick: false,
        go: function() {
            this.goResizeImage();
        
            this.goSidebar();
        
            this.goScrollTop();
           
            this.goAddToCart();
            this.goBox();
            this.goProductAddToCart();
            this.goWishlist();
            this.goProductWishlist();
         
        },
        sidebarMapTagEvents: function() {
            $(".sidebar-tag a, .sidebar-tag label").click(function(n) {
                var r = [];
                if (Shopify.queryParams.constraint) {
                    r = Shopify.queryParams.constraint.split("+")
                }
                if (!window.enable_sidebar_multiple_choice && !$(this).prev().is(":checked")) {
                    var i = $(this).parents(".sidebar-tag").find("input:checked");
                    if (i.length > 0) {
                        var s = i.val();
                        if (s) {
                            var o = r.indexOf(s);
                            if (o >= 0) {
                                r.splice(o, 1)
                            }
                        }
                    }
                }
                var s = $(this).prev().val();
                if (s) {
                    var o = r.indexOf(s);
                    if (o >= 0) {
                        r.splice(o, 1)
                    } else {
                        r.push(s)
                    }
                }
                if (r.length) {
                    Shopify.queryParams.constraint = r.join("+")
                } else {
                    delete Shopify.queryParams.constraint
                }
                t.sidebarAjaxClick();
                n.preventDefault()
            })
        },


        sidebarMapEvents: function() {
            t.sidebarMapTagEvents();
           
        },

 
        sidebarMapData: function(n) {
            var r = $(".col-main .products-grid");
            if (r.length == 0) {
                r = $(".col-main .product-list")
            }
            var i = $(n).find(".col-main .products-grid");
            if (i.length == 0) {
                i = $(n).find(".col-main .product-list")
            }
            if (i.length > 0 && i.hasClass("products-grid")) {
                if (window.product_image_resize) {
                    i.find("img").fakecrop({
                        fill: window.images_size.is_crop,
                        widthSelector: ".products-grid .grid-item .product-image",
                        ratioWrapper: window.images_size
                    })
                }
            }
            r.replaceWith(i);
    
            var s = $(".page-header");
            var o = $(n).find(".page-header");
            if (s.find("h2").text() != o.find("h2").text()) {
                s.find("h2").replaceWith(o.find("h2"));
                if (s.find(".rte").length) {
                    if (o.find(".rte").length) {
                        s.find(".rte").replaceWith(o.find(".rte"))
                    } else {
                        s.find(".rte").hide()
                    }
                } else {
                    if (o.find(".rte").length) {
                        s.find("h2").after(o.find(".rte"))
                    }
                }
            }
            $(".refined-widgets").replaceWith($(n).find(".refined-widgets"));
            $(".sidebar-block").replaceWith($(n).find(".sidebar-block"))
        },
        sidebarCreateUrl: function(t) {
            var n = $.param(Shopify.queryParams).replace(/%2B/g, "+");
            if (t) {
                if (n != "") return t + "?" + n;
                else return t
            }
            return location.pathname + "?" + n
        },
        sidebarAjaxClick: function(e) {
            delete Shopify.queryParams.page;
            var n = t.sidebarCreateUrl(e);
            t.isSidebarAjaxClick = true;
            History.pushState({
                param: Shopify.queryParams
            }, n, n);
            t.sidebarGetContent(n)
        },
        sidebarGetContent: function(n) {
            $.ajax({
                type: "get",
                url: n,
                beforeSend: function() {
                    t.showLoading()
                },
                success: function(e) {
                    t.sidebarMapData(e);
                 
                    t.sidebarMapTagEvents();
                    t.hideLoading();
                  
                    t.goAddToCart();
                    t.goWishlist()
                },
                error: function(n, r) {
                    t.hideLoading();
                    $(".loading").hide();
                    $(".ajax-error-message").text($.parseJSON(n.responseText).description);
                    t.showBox(".ajax-error-cbox")
                }
            })
        },
        sidebarParams: function() {
            Shopify.queryParams = {};
            if (location.search.length) {
                for (var e, t = 0, n = location.search.substr(1).split("&"); t < n.length; t++) {
                    e = n[t].split("=");
                    if ($.length > 1) {
                        Shopify.queryParams[decodeURIComponent(e[0])] = decodeURIComponent(e[1])
                    }
                }
            }
        },

        goSidebar: function() {
            if ($("#filter-sidebar").length > 0) {
                t.sidebarParams();
                t.sidebarMapEvents()
            }
        },
       
        goWishlist: function() {
            $(".grid-item button.wishlist").click(function(n) {
                n.preventDefault();
                var r = $(this).parent();
                var i = r.parents(".grid-item");
                $.ajax({
                    type: "POST",
                    url: "/contact",
                    data: r.serialize(),
                    beforeSend: function() {
                        t.showLoading()
                    },
                    success: function(n) {
                        t.hideLoading();
                        r.html('<a class="wishlist" href="/pages/wish-list" title="Go to wishlist"><span class="icon"></span><span>Go to wishlist</span></a>');
                        $(".ajax-success-cbox").find(".show-wishlist").show();
                        $(".ajax-success-cbox").find(".show-cart").hide();
                        t.showBox(".ajax-success-cbox")
                    },
                    error: function(n, r) {
                        t.hideLoading();
                        $(".loading").hide();
                        $(".ajax-error-message").text($.parseJSON(n.responseText).description);
                        t.showBox(".ajax-error-cbox")
                    }
                })
            })
        },
        goProductWishlist: function() {
            $(".product button.wishlist").click(function(n) {
                n.preventDefault();
                var r = $(this).parent();
                var i = r.parents(".grid-item");
                $.ajax({
                    type: "POST",
                    url: "/contact",
                    data: r.serialize(),
                    beforeSend: function() {
                        t.showLoading()
                    },
                    success: function(n) {
                        t.hideLoading();
                        r.html('<a class="wishlist" href="/pages/wish-list" title="Go to wishlist"><span class="icon"></span><span>Go to wishlist</span></a>');
                        $(".ajax-success-cbox").find(".show-wishlist").show();
                        $(".ajax-success-cbox").find(".show-cart").hide();
                        t.showBox(".ajax-success-cbox")
                    },
                    error: function(n, r) {
                        t.hideLoading();
                        $(".loading").hide();
                        $(".ajax-error-message").text($.parseJSON(n.responseText).description);
                        t.showBox(".ajax-error-cbox")
                    }
                })
            })
        },

        goResizeImage: function() {
            if (window.product_image_resize) {
                $(".products-grid .product-image img").fakecrop({
                    fill: window.images_size.is_crop,
                    widthSelector: ".products-grid .grid-item .product-image",
                    ratioWrapper: window.images_size
                })
            }
        },
 
       
     
        showBox: function(n) {
            $(n).fadeIn(500);
            t.atTimeout = setTimeout(function() {
                $(n).fadeOut(500)
            }, 5e3)
        },


        goBox: function() {
            $(".continue-shopping").click(function() {
                clearTimeout(t.atTimeout);
                $(".ajax-success-cbox").fadeOut(500)
            });
            $(".close-cbox").click(function() {
                clearTimeout(t.atTimeout);
                $(".ajax-success-cbox").fadeOut(500)
            })
        },

   
       
        
      
        goScrollTop: function() {
            $("#back-top").click(function() {
                $("body,html").animate({
                    scrollTop: 0
                }, 400);
                return false
            })
        },
        goProductAddToCart: function() {
            if ($("#product-add-to-cart").length > 0) {
                $("#product-add-to-cart").click(function(n) {
                    n.preventDefault();
                    if ($(this).attr("disabled") != "disabled") {
                        if (!window.ajax_cart) {
                            $(this).closest("form").submit()
                        } else {
                            var r = $("#add-to-cart-form select[name=id]").val();
                            if (!r) {
                                r = $("#add-to-cart-form input[name=id]").val()
                            }
                            var i = $("#add-to-cart-form input[name=quantity]").val();
                            if (!i) {
                                i = 1
                            }
                     
                            var o = $("#product-featured-image").attr("src");
                            t.doAjaxAddToCart(r, i, o)
                        }
                    }
                    return false
                })
            }
        },
        goAddToCart: function() {
            if ($(".add-to-cart-btn").length > 0) {
                $(".add-to-cart-btn").click(function(n) {
                    n.preventDefault();
                    if ($(this).attr("disabled") != "disabled") {
                        var r = $(this).parents(".product-item");
                        var i = $(r).attr("id");
                        i = i.match(/\d+/g);
                        if (!window.ajax_cart) {
                            $("#product-actions-" + i).submit()
                        } else {
                            var s = $("#product-actions-" + i + " select[name=id]").val();
                            if (!s) {
                                s = $("#product-actions-" + i + " input[name=id]").val()
                            }
                            var o = $("#product-actions-" + i + " input[name=quantity]").val();
                            if (!o) {
                                o = 1
                            }
                            t.doAjaxAddToCart(s, o)
                        }
                    
                    }
                    return false
                })
            }
        },
        showLoading: function() {
            $(".loading").show()
        },
        hideLoading: function() {
            $(".loading").hide()
        },
        doAjaxAddToCart: function(n, r, i, s) {
            $.ajax({
                type: "post",
                url: "/cart/add.js",
                data: "quantity=" + r + "&id=" + n,
                dataType: "json",
                beforeSend: function() {
                    t.showLoading()
                },
                success: function(n) {
                    t.hideLoading();
                    $(".ajax-success-cbox").find(".show-wishlist").hide();
                    $(".ajax-success-cbox").find(".show-cart").show();
                    t.showBox(".ajax-success-cbox");
                    t.updateDropdownCart()
                },
                error: function(n, r) {
                    t.hideLoading();
                    $(".ajax-error-message").text($.parseJSON(n.responseText).description);
                    t.showBox(".ajax-error-cbox")
                }
            })
        },
    
        updateDropdownCart: function() {
            Shopify.getCart(function(e) {
                t.doUpdateDropdownCart(e)
            })
        },
        doUpdateDropdownCart: function(n) {
            $("#cart-count").text(n.item_count);
        },
    

        convertToSlug: function(e) {
            return $.toLowerCase().replace(/[^a-z0-9 -]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-")
        },
       
      
    }
    
    jQuery(window).scroll(function() {
      if (jQuery(this).scrollTop() > 200) {
        jQuery("#back-top").fadeIn()
      } else {
        jQuery("#back-top").fadeOut()
      }
    });
    jQuery( ".footer-top h3.module-title" ).append( '<i class="arrow_carrot-down"></i>' );
    jQuery(".footer-top .content").hide();
    jQuery(".footer-top h3.module-title i").addClass("accordion-show");
    jQuery(".footer-top h3.module-title i").click(function(){
      if(jQuery(this).parent().next().is(":visible")){
        jQuery(this).addClass("accordion-show");
      }else{
        jQuery(this).removeClass("accordion-show");
      }
      jQuery(this).parent().next().toggle(400);
    });



 


  jQuery(document).ready(function($){

    jQuery("a.zoom").fancybox({
      padding:0,
      'titleShow': false,
      overlayColor: '#000000',
      overlayOpacity: 0.2
    });

    /* Update main product image when a thumbnail is clicked. */
    /*==========================*/
    jQuery('#product .thumbs a').on('click', function(e) {
      e.preventDefault();
      switchImage(jQuery(this).attr('href'), null, jQuery('.featured img')[0]);
    } );


    /* Initialize zoom on main product image */
    var mainProductImage = jQuery('.featured img');
    if (mainProductImage.size()) {
      if (jQuery(window).width() > 782) {
      var zoomedSrc = $('.featured img').attr('src').replace('_master', '');
      $('.featured img')
        .wrap('<span style="display:inline-block; max-width: 100%;"></span>')
        .css('display', 'block')
        .parent()
        .zoom( { url: zoomedSrc } );
      }
    }
  });
})(jQuery);